module.exports = __webpack_public_path__ + "cc407ad20b8f3fce59e8d8b236e2e0b1.pdf";